<template>
  <ProductFilter
    :isOnProductDetailPage="isOnProductDetailPage"
    :placeholderText="placeholderText"
    :totalFiltersActive="totalFiltersActive"
    filterType="option"
    title="Options"
    tooltipText="For example, size or color."
  />
</template>

<script>
  import ProductFilter from '@/components/ProductFilter'

  export default {
    name: 'ProductFilterOptions',
    components: {
      ProductFilter
    },
    props: {
      isOnProductDetailPage: Boolean,
      totalFiltersActive: Number
    },
    computed: {
      placeholderText: function () {
        return 'Start typing "Small"'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductFilterOptions.vue